// +-------------------------------------------------------------
// | Created by WebStorm.
// +-------------------------------------------------------------
// | User: msmile
// +-------------------------------------------------------------
// | Date: 2025/5/8
// +-------------------------------------------------------------
// |Time: 17:38
// +-------------------------------------------------------------
import BasicLayout from "@/layouts/BasicLayout.vue";
import Order from "@/router/module/order";
import Goods from "@/router/module/goods";
import User from "@/router/module/user";
export default [
    {
        path: '/',
        redirect: '/home'
    },
    {
        path: '/home',
        name: 'BasicLayout',
        redirect: '/dashboard',
        component: BasicLayout,
        children: [
            {
                path: '/dashboard',
                name: 'AppDashboard',
                component: () => import('@/views/Home/Dashboard'),
                meta: {title: '首页'},
            },
            {
                path: '/goods',
                name: 'GoodsList',
                component: () => import('@/views/Goods/GoodsList/Index.vue'),
                meta: {title: '全部商品'},
            },
            {
                path: '/user',
                name: 'UserCenter',
                component: () => import('@/views/User/Center/Index.vue'),
                meta: {title: '个人中心'},
            }
        ]
    },
    ...Goods,
    ...Order,
    ...User,
    {
        path: '/not-underage-recharge',
        name: 'NotUnderageRecharge',
        component: () => import('@/views/Others/Article/NotUnderageRecharge.vue'),
        meta: {title: '充值说明'},
    },
    {
        path: '/customer-service',
        name: 'CustomerService',
        component: () => import('@/views/Others/CustomerService/Index.vue'),
        meta: {title: '客服中心'},
    }
]